// Annuaire vitrine des partenaires — structure extensible.
// Pour ajouter un partenaire : ajouter un objet dans `partners` du métier concerné.
// Pour ajouter un métier : ajouter un objet dans METIERS (la page /partenaires/:slug,
// le hub, le fil d'Ariane et le garde-fou SEO suivent automatiquement — penser juste
// à ajouter la route dans pageMeta.json et le sitemap).

export const METIERS = [
  {
    slug: "ferronnerie",
    name: "Ferronnerie",
    title: "Nos partenaires en ferronnerie",
    lead: "Le fer forgé donne aux sculptures leur ossature et leur présence. Voici les ateliers de ferronnerie d'art avec lesquels nous collaborons.",
    materiauxSlug: "metal",
    partners: [
      {
        id: "art-de-forge",
        name: "Jérôme Mazoyer — Art de Forge",
        role: "Ferronnier d'art, Valréas (Vaucluse)",
        city: "Valréas (Vaucluse)",
        blurb:
          "Ferronnier d'art installé à Valréas, il forge des pièces métalliques sur mesure — sculpture, mobilier, ouvrages d'architecture — avec la rigueur de la forge traditionnelle.",
        paragraphs: [
          "Installé à Valréas, dans le Vaucluse, Jérôme Mazoyer dirige l'atelier Art de Forge, spécialisé dans la ferronnerie d'art et la fabrication métallique sur mesure : forge, soudure, métal découpé, pièces uniques.",
          "L'atelier accompagne aussi des projets sculpturaux : structure interne, assemblage, soudure et finitions du métal, de la pièce intime à l'œuvre monumentale. Un beau terrain de rencontre entre la rigueur du travail du fer et la liberté de la sculpture contemporaine.",
          "Au-delà des pièces sur mesure, Art de Forge réalise aussi portails, rampes et ouvrages de ferronnerie classique pour particuliers et professionnels.",
        ],
        cta: "Vous avez un projet de ferronnerie ? Contactez Jérôme au 06 80 70 14 56.",
        contact: {
          company: "Art de Forge SARL",
          addressLines: ["Z.I. de la Grèze — Allée Germain Aubert", "84600 Valréas"],
          tel: "06 80 70 14 56",
          telHref: "+33680701456",
          fax: "04 90 37 62 47",
          email: "art-de-forge@orange.fr",
        },
        photo: {
          src: "/images/arbre-sculptural-metal-forge.jpg",
          alt: "Arbre sculptural en métal forgé, réalisé par l'atelier Art de Forge, installé sur un rond-point urbain",
          caption: "Arbre sculptural en métal forgé, 4 m — atelier Art de Forge, Valréas",
          link: "https://www.arson-sculptures.com/product-page/sculpture-contemporaine-arbre-monumental-metallique",
          linkLabel: "Voir une sculpture monumentale en métal",
        },
      },
    ],
  },
  {
    slug: "resine",
    name: "Résine",
    title: "Nos partenaires en résine",
    lead: "Moulage, tirage en série, finitions peintes : la résine demande une précision d'atelier. Voici les fabricants avec lesquels nous collaborons.",
    materiauxSlug: "resine",
    partners: [
      {
        id: "evoludis-concept",
        name: "Antoine Odent — Evoludis Concept",
        role: "Fabrication résine, Vila Nova de Famalicão (Portugal)",
        city: "Vila Nova de Famalicão (Portugal)",
        blurb:
          "Spécialiste du moulage et du tirage en résine, il réalise séries et finitions peintes pour des sculpteurs et des professionnels, de l'atelier portugais à l'œuvre.",
        paragraphs: [
          "Basé au Portugal, Antoine Odent dirige Evoludis Concept, spécialisé dans le moulage, le tirage et les finitions (peinture et décor) de pièces en résine.",
          "Son atelier prend en charge l'ensemble de la fabrication : réalisation des moules d'après le modèle du sculpteur, tirages en série soignés, puis finitions chromées ou laquées, jusqu'à la pièce prête à présenter.",
          "Evoludis Concept accompagne aussi d'autres artistes et professionnels dans leurs projets de fabrication en résine.",
        ],
        cta: "Vous avez un projet de moulage ou de tirage en résine ? Contactez Antoine au +351 925 160 794 (WhatsApp disponible).",
        contact: {
          company: "Evoludis Concept",
          addressLines: ["Rua do Senhor dos Perdões, nº14", "4760-727 Ribeirão — Vila Nova de Famalicão, Portugal"],
          tel: "+351 925 160 794",
          telHref: "+351925160794",
          fax: null,
          email: "antoine.odent@evoludis.pt",
        },
        photo: {
          src: "/images/sculpture-pop-resine-chromee-rose.jpg",
          alt: "Sculpture pop en résine, finition rose chromée — moulage et finition par Evoludis Concept",
          caption: "Sculpture pop en résine, finition rose chromée — moulage et finition par Evoludis Concept",
          link: "https://www.arson-sculptures.com/product-page/sculpture-de-bonbons-pop-art-resine",
          linkLabel: "Voir la sculpture terminée",
        },
      },
    ],
  },
  {
    slug: "fonderie-art",
    name: "Fondeur d’art",
    title: "Nos partenaires en fonderie d’art",
    lead: "Bronze, moules, coulage, patine, coulage : les artisans qui donnent sa puissance à une sculpture.",
    materiauxSlug: "bronze",
    partners: [
      {
        id: "fonderie-du-peroux",
        detailPage: true,
        name: "Fonderie du Péroux",
        role: "Fonderie d’art, Vonnas (Ain)",
        city: "Vonnas 01540",
        blurb: "Fonderie d’art à Vonnas : fonte à la cire perdue et au sable, bronze, laiton et aluminium, pour les artistes et sculpteurs.",
        logoCard: {
          src: "/images/fdp-vague.webp",
          alt: "sculpture bronze fonderie du Péroux",
        },
        contact: {
          company: "Fonderie du Péroux",
          addressLines: ["2075 Rte de Péroux, 01290 Biziat"],
          tel: "06 32 79 71 56",
          telHref: "+33632797156",
          email: "fonderieduperoux@gmail.com",
        },
      },
    ],
  },
  {
    slug: "finitions",
    name: "Finitions et décors de surface",
    title: "Nos partenaires en finitions et décors de surface",
    lead: "Peinture, patine, vernis, décor par transfert : les artisans qui donnent sa surface finale à une sculpture.",
    partners: [
      {
        id: "hydrographie-concept",
        detailPage: true,
        name: "Hydrographie Concept",
        role: "Atelier d'hydrographie (impression hydrographique)",
        city: "Saint-Just-Saint-Rambert (Loire)",
        blurb:
          "Hydrographie peinture et impression hydrographique sur tous supports : environ 6 000 motifs, projets uniques et sur mesure, pour particuliers et professionnels.",
        logoCard: {
          src: "/images/hydrographie-concept-logo.webp",
          alt: "Logo Hydrographie Concept",
        },
        contact: {
          company: "Hydrographie Concept",
          addressLines: ["Saint-Just-Saint-Rambert (Loire)"],
        },
      },
    ],
  },
];

// Métier d'art associé à chaque fiche matériau (pour l'encadré « Artisans partenaires »,
// état vide : « Vous êtes fondeur d'art ? » etc.)
export const TRADE_BY_MATERIAL = {
  bronze: "fondeur d'art",
  resine: "fabricant de résine",
  platre: "mouleur",
  metal: "ferronnier d'art",
  bois: "sculpteur sur bois",
  pierre: "tailleur de pierre",
  terre: "céramiste ou potier",
};

// Partenaires correspondant à une fiche matériau (via materiauxSlug du métier)
export const partnersForMaterial = (materialSlug) =>
  METIERS.filter((m) => m.materiauxSlug === materialSlug).flatMap((m) =>
    m.partners.map((p) => ({ ...p, metierSlug: m.slug, metierName: m.name }))
  );
